<template>
	<div class="convention-hall page">
		<van-nav-bar class="nav-bar" :title="$t('reservation.hall')" >
			<!-- <template #left>
					<van-icon name="bars" color="#d5b9a4" size="24" @click="drawer = true" />
			</template> -->
		</van-nav-bar>
		
		<div class="convention-item">
			<van-tabs animated sticky line-width="100px" :swipeable="true">
				<van-tab :title="$t('concubine.city')">
					<div class="card">{{$t("concubine.city_tip")}}</div>
					<div class="address">
						<van-cell-group v-for="(val, key) in addlist" :key="key" >
						<van-cell @click="addgo"><img :src="val.url" class="images" /></van-cell>
						</van-cell-group>
						<!-- <van-row type="flex" justify="" gutter="65" v-for="(val, key) in addlist" :key="key">
							<van-col span="" offset="" @click="addgo(v)" v-for="(v, k) in val" :key="k">{{ v.name }}</van-col>
						</van-row> -->
						<div class="more" @click="addgo">查看更多女生資訊</div>
					</div>
					
				</van-tab>
				<van-tab :title="$t('concubine.price')">
					<div class="card">{{$t("concubine.city_tip")}}</div>
					<div class="rig-box">
						<p class="rig-title">{{$t("concubine.pri_resource")}}</p>
						<p class="rig-content">{{$t("concubine.pri_obj")}}</p>
						<p class="rig-title">{{$t("concubine.pri_service")}}</p>
						<p class="rig-content">{{$t("concubine.pric_service_one")}}</p>
						<p class="rig-content">{{$t("concubine.pric_service_two")}}</p>
					</div>
				</van-tab>
			</van-tabs>
		</div>
		<!-- 左侧抽屉组件 -->
		<el-drawer
		  title=""
		  :visible.sync="drawer"
		  direction="ltr"
		  size="300px"
		  custom-class="my-drawer"
		  :before-close="handleClose">
		  <div>
			<div class="menu-item" @click="toLogin('/Home')">{{ $t("foorter.index") }}</div>
			<div class="menu-item" @click="toLogin('/Lottery?key=game1&id=10')">{{ $t("foorter.subscribe") }}</div>
			<div class="menu-item" @click="drawer = false">{{ $t('concubine.concubine') }}</div>
			<div class="menu-item" @click="toLogin('/Video')">{{ $t("foorter.video") }}</div>
			<div class="menu-item" @click="toLogin('/Mine')">{{ $t("foorter.my") }}</div>
		  </div>
		</el-drawer>
	</div>
</template>

<script>
export default {
	data() {
		return {
			drawer: false, // 控制抽屉打开状态
			kefu: '',
			addlist: [
				{
					url: require('../images/choose/1.jpg')
				},
				{
					url: require('../images/choose/2.jpg')
				},
				{
					url: require('../images/choose/3.jpg')
				},
				{
					url: require('../images/choose/4.jpg')
				},
				{
					url: require('../images/choose/5.jpg')
				},
				{
					url: require('../images/choose/6.jpg')
				},
				{
					url: require('../images/choose/7.jpg')
				},
				{
					url: require('../images/choose/8.jpg')
				},
				{
					url: require('../images/choose/9.jpg')
				},
				{
					url: require('../images/choose/10.jpg')
				},
			]
		};
	},
	methods: {
		handleClose(done) {
		  done();
		},
		toLogin(str) {
		  this.$router.push({ path: str});
		},
		addgo() {
			if(this.kefu) window.open(this.kefu)
			// if (!localStorage.getItem('token')) {
			// 	this.$router.push({ path: '/Login' });
			// } else {
			// 	this.$router.push({ path: '/list?id=' + data.id + '&name=' + data.name });
			// }
		},
		getAddress() {
			this.$http({
				method: 'get',
				url: 'address_list'
			}).then(res => {
				this.addlist = res.data;
				this.addlist= [{name:1},{name:2},{name:3},{name:4},{name:4},{name:4},{name:4},{name:4},{name:4},{name:4}]
				console.log(res.data)
			});
		},
		getKefu() {
			this.$http({
				method: 'get',
				url: 'base_info'
			}).then(res => {
				// console.log('rs', res.data.telegram)
				this.kefu = res.data ? res.data.telegram : ''
			});
		}
	},
	created() {
		this.getKefu();
	}
};
</script>

<style lang="less" scoped>
.page {
	position: absolute !important;
	top: 0;
	left: 0;
	right: 0;
	background-color:@pageBg;
}
// .nav-bar {
// 	background: linear-gradient(247deg, #493131, #b917e3);
// 	height: 100px;
// }
.van-nav-bar {
	line-height: 50px;
}
::v-deep .van-nav-bar__title {
	max-width: 60%;
	margin: 0 auto;
	color: #ffffff;
	font-size: 35px;
}
::v-deep .van-nav-bar__content {
	height: 100px;
}
.van-sidebar {
	width: 180px;
}
.convention-item{
	background-color:@pageBg;
}
// /deep/ .van-col{
	// padding: 30px 0px;
// }
.convention-hall {
	display: flex;
	flex-direction: column;
	bottom: 20px;
	background: #f2f2f5;
	height: max-content;
}
::v-deep .van-tab {
	font-size: 30px;
	line-height: 100px;
	font-weight: bold;
}
::v-deep .van-tab--active {
    color: @theme3;
    font-weight: 500;
}
::v-deep .van-tabs__line {
	background-color: @theme3;
}
::v-deep .van-tabs--line .van-tabs__wrap {
	height: 100px;
}
::v-deep .van-tabs__wrap--scrollable .van-tab {
	padding: 0 23px;
}
.card {
	background-color: #8a637d;
	padding: 0.625rem;
	width: 95%;
	color: white;
	font-size: 0.8125rem;
	margin: 0.625rem auto;
	border-radius: 0.375rem;
}
::v-deep .van-row--flex {
	height: 80px;
	line-height: 80px;
}

/deep/ .van-cell{
	padding: 8px 4px;
	font-size: 30px;
	line-height:30px;
	background-color:@pageBg;
	height: 100%;
}
.rig-box {
	width: 95%;
	margin: 0.625rem auto;
}
.rig-title {
	color: #0bdab0;
	font-size: 1.125rem;
}
.rig-content {
	font-size: 20px;
	// margin-top: 10px;
}
.address {
	width: 94%;
	margin: 0 auto;
	margin-bottom: 110px;
}

::v-deep .my-drawer {
  background-color: #f6f6f5;
  
  .el-drawer__body {
    background-color: #f6f6f5;
    color: #333;
  }
}
.menu-item{
	padding: 2vh 0 2vh 5vw;
	font-weight: 700;
	font-style: normal;
	font-family: Lato, sans-serif;
	font-size: .8em;
	border-top: 1px solid #ececec;
}
.van-cell-group{
	width: 50%;
	float: left;
	height: 25vh;
}
.images{
	width: 100%;
	height: 100%;
}
.more{
	width: 100%;
	height: 5vh;
	float: left;
	margin-bottom: 200px;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #232727;
	margin-top: 1vh;
}
</style>
